import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Topbar from '../../components/Bar/Topbar';
import Header from '../../components/Bar/Header';
import Footer from '../../components/Footer/Footer';
import CardFidelty from '../../components/Carousel/CardFidelty';
import MainContainerAdhesion2 from '../../components/Carousel/MainContainerAdhesion2';

const colors = {
  bg: '#FFFFFF',
  gold: '#C69C6D',
  goldDark: '#B88A56',
  text: '#3B2F2A',
};

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <style>{`
        .contact-page {
          background: ${colors.bg};
          min-height: 100vh;
          position: relative;
          overflow: hidden;
        }

        /* Halos dorés subtils */
        .contact-page::before,
        .contact-page::after {
          content: '';
          position: fixed;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.15;
          z-index: 0;
          pointer-events: none;
        }

        .contact-page::before {
          width: 50vw;
          height: 50vw;
          background: #F5E1C8;
          top: -10%;
          left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }

        .contact-page::after {
          width: 40vw;
          height: 40vw;
          background: #EAD5C0;
          bottom: -8%;
          right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }

        .content-wrapper {
          position: relative;
          z-index: 1;
          padding-top: 80px; /* hauteur du header */
        }

        .page-title {
          font-size: clamp(2.2rem, 5vw, 3rem);
          font-weight: 700;
          color: ${colors.text};
          text-align: center;
          margin: 0 0 0.5rem;
          letter-spacing: -0.5px;
        }

        .title-underline {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${colors.gold}, ${colors.goldDark});
          margin: 0 auto 50px;
          border-radius: 2px;
        }

        @media (max-width: 768px) {
          .content-wrapper {
            padding-top: 70px;
            padding-left: 16px;
            padding-right: 16px;
          }
        }
      `}</style>


      <Header />

      <motion.div
        className="contact-page"
        variants={pageVariants}
        initial="initial"
        animate="animate"
      >
        <div className="content-wrapper">
        
          <motion.div
            className="title-underline"
            initial={{ width: 0 }}
            animate={{ width: 80 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          />

          <CardFidelty />
       
        </div>
      </motion.div>

      <Footer />
    </>
  );
};

export default Contact;